import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import moment from 'moment';

// COMPONENTS
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import {
  FilterFormContainer,
  FilterFormTitle,
  ButtonsContainer,
  FilterItemGroup,
  RadioContainer,
  FilterInput,
} from './styles';

import { FILTER_TYPES, FILTER_FORM, FilterInputType } from 'constants/filters';
import { ifInTestingMode } from 'utils/tests.utils';

class DateConfiguration extends Component {
  state = {
    query: '',
    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    option: FILTER_FORM[this.props.column.get('type')][0],
  };

  getFormItems = () =>
    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    FILTER_FORM[this.props.column.get('type')]
      .filter((item) => !item.disabled)
      .map((item) => (
        <FilterItemGroup
          key={`string-filter-${item.translation}`}
          data-testid={ifInTestingMode(`filter__${item.translation}`)}
        >
          <RadioContainer>
            <RadioButton
              onClick={this.handleChangeOption(item)}
              // @ts-expect-error TS(2769): No overload matches this call.
              selected={item.translation === this.state.option.translation}
              renderedValue={{
                translationId: `components.Filters.${item.translation}`,
              }}
            />
          </RadioContainer>

          {item.translation === this.state.option.translation &&
            [FilterInputType.INPUT, FilterInputType.RANGE].includes(this.state.option.type) && (
              <>
                {this.state.option.type === FilterInputType.RANGE && (
                  <label htmlFor="query">
                    <FormattedMessage id="components.Filters.fromDate" />
                  </label>
                )}
                <FilterInput
                  id="query"
                  type="date"
                  name="query"
                  // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                  placeholder={this.props.intl.formatMessage({
                    id: 'components.Filters.valuePlaceholder',
                  })}
                  value={
                    this.state.option.type === FilterInputType.INPUT
                      ? this.state.query
                      : this.state.query.split(',')[0] ?? ''
                  }
                  onChange={
                    this.state.option.type === FilterInputType.INPUT
                      ? this.handleChangeQuery
                      : (event) => this.handleRangeChange(event, 0)
                  }
                />
              </>
            )}
          {item.translation === this.state.option.translation && this.state.option.type === FilterInputType.RANGE && (
            <>
              <label htmlFor="query-to">
                <FormattedMessage id="components.Filters.toDate" />
              </label>
              <FilterInput
                id="query-to"
                type="date"
                name="query-to"
                // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                placeholder={this.props.intl.formatMessage({
                  id: 'components.Filters.valuePlaceholder',
                })}
                value={this.state.query.split(',')[1] ?? ''}
                onChange={(event) => this.handleRangeChange(event, 1)}
              />
            </>
          )}
        </FilterItemGroup>
      ));

  handleChangeQuery = (event) => {
    this.setState({ query: event.currentTarget.value });
  };

  handleRangeChange = (event, position: number) => {
    let [from, to] = this.state.query.split(',');

    if (position === 0) {
      from = event.currentTarget.value;
    } else {
      to = event.currentTarget.value;
    }

    if (typeof to === 'undefined') {
      to = '';
    }

    this.setState({ query: `${from},${to}` });
  };

  handleChangeOption = (option) => () => {
    this.setState({ option });
  };

  handleSaveFilter = () => {
    let value = null;

    if (this.state.option.type) {
      value = this.state.query;
    } else if (this.state.option.translation === 'isKnown') {
      value = '0';
    } else if (this.state.option.translation === 'isUnknown') {
      value = '1';
    }

    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (this.props.column.get('type') === FILTER_TYPES.dateTime) {
      if (this.state.query.includes(',')) {
        const dates = this.state.query.split(',');
        value = dates.map((date) => moment(date).utc().format()).join(',');
      } else {
        value = moment(this.state.query).utc().format();
      }
    }

    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(
      fromJS({
        comparator: this.state.option.comparator,
        // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
        field: this.props.column.get('name'),
        value,
      })
    );
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        {this.getFormItems()}

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid={ifInTestingMode('filters__apply')} onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(DateConfiguration);
